import { useMutation, useQueryClient } from 'react-query';
import { successToast } from 'lib/components/toasts/success';
import { errorToast } from 'lib/components/toasts/error';
import { teleprompterKeys } from './queryKeys';
import { EXPRESS_API } from 'configs/api/expressApi';
import { useTranslation } from 'react-i18next';

const copyScript = async (scriptId: number) => {
  const response = await EXPRESS_API.post(`/teleprompter/${scriptId}/copy`);
  return response.data;
};

export const useCopyScript = (scope: string) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation((scriptId: number) => copyScript(scriptId), {
    onSuccess: () => {
      queryClient.invalidateQueries(teleprompterKeys.list(scope));

      successToast({ title: t('Successfully copied to My Scripts!') });
    },
    onError: () => {
      errorToast({ title: t('There was an error with copying your script.') });
    },
  });
};
